import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=5c8787b1&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8787b1')) {
      api.createRecord('5c8787b1', component.options)
    } else {
      api.reload('5c8787b1', component.options)
    }
    module.hot.accept("./tab.vue?vue&type=template&id=5c8787b1&", function () {
      api.rerender('5c8787b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/fee/views/new_fee/cost_manage/form/components/tab.vue"
export default component.exports